import React, { useContext } from 'react';
import { FiltersContext } from 'app/containers/contexts/filters.context/filters.context';
import { useCategoryLocationKey, useMenuPeriodsData } from 'app/hooks/accessors';
import {
    CATEGORIES_ORDER, CATEGORIES_ORDER_MOBILE, CATEGORY_FARM_PRODUCTS,
    isCategoryVisibleForLocation,
} from 'app/const/categories';
import { isDesktop } from 'app/utils/resolution';

type TypePeriod = {
    start: string
}

type TypeCategory = {
    id: string,
    title: string,
}

function sortCategoriesByOrder(categories: any[], orderArray: string[]): any[] {
    const orderMap = new Map<string, number>();
    orderArray.forEach((id, index) => {
        orderMap.set(id, index);
    });

    return [...categories].sort((a, b) => {
        const indexA = orderMap.get(a.id);
        const indexB = orderMap.get(b.id);

        if (indexA === undefined && indexB === undefined) return 0;
        if (indexA === undefined) return 1;
        if (indexB === undefined) return -1;

        return indexA - indexB;
    });
}

export const useAvailableCategories = () => {
    const isDesktopResolution = isDesktop();
    const {
        selectedFilters: { selectedPeriod, selectedCategories, selectedTags },
    } = useContext<any>(FiltersContext);

    const menuFilter = useMenuPeriodsData();
    const locationKey = useCategoryLocationKey();

    const period = menuFilter.periods.find((p: TypePeriod) => p.start === selectedPeriod);
    const categories = period?.categories || [];
    const filteredCategories = categories
        .filter((c: TypeCategory) => selectedCategories.includes(c.id))
        .filter((c: TypeCategory) => isCategoryVisibleForLocation(c.id, locationKey));

    const dishesProvidedData: any = {
        categories,
        selectedCategories,
        selectedTags,
        menuFilter,
    };

    const sortedCategoriesByOrder = sortCategoriesByOrder(
        filteredCategories,
        !isDesktopResolution
            ? CATEGORIES_ORDER_MOBILE
            : CATEGORIES_ORDER,
    );

    return [
        !isDesktopResolution
            ? sortedCategoriesByOrder?.filter((e) => e.id !== CATEGORY_FARM_PRODUCTS)
            : sortedCategoriesByOrder,
        dishesProvidedData,
    ];
};
